import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from 'app/core/supabase/supabase.service';
import { from, of, switchMap } from 'rxjs';

/**
 * Forces users whose auth metadata carries `must_change_password: true`
 * (e.g. lawyers invited with a temporary password) to set a new password
 * before accessing the admin panel. Redirects them to /auth/change-password.
 *
 * Lee de la sesion local en vez de `getUser()`: este guard corre en cada
 * navegacion de /admin y esa llamada salia a la red cada vez. El
 * `user_metadata` viaja en la propia sesion.
 */
export const MustChangePasswordGuard: CanActivateFn | CanActivateChildFn = () => {
    const router: Router = inject(Router);
    const supabase = inject(SupabaseService);

    // Con el flag ya conocido el guard es síncrono: la vista abre sin esperar nada.
    const cached = supabase.mustChangePasswordCached;
    if (cached !== null) {
        return cached ? router.parseUrl('/auth/change-password') : true;
    }

    return from(supabase.getSession()).pipe(
        switchMap((session) => {
            if (session?.user?.user_metadata?.must_change_password === true) {
                return of(router.parseUrl('/auth/change-password'));
            }
            return of(true);
        })
    );
};
